namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsVatRefundDtEditor extends Serenity.Extensions.GridEditorBase<PsVatRefundDtRow> {
        protected getColumnsKey() { return "PosShift.PsVatRefundDt"; }
        protected getDialogType() { return PsVatRefundDtDialog; }
        protected getLocalTextPrefix() { return PsVatRefundDtRow.localTextPrefix; }

        public qnNo: number;

        public myPassValue: string;
        public supid: string;
        public totalamt: number;
        public shopid: string;


        public whsid: string;
        public sumaloamt: number;

        public salevattype: string;
        public doctype: number;

        private _sup: string;

        private _CallPR: string;
        private _CallTax: string;

        private _delPR: string;
        private _delTax: string;


        constructor(container: JQuery) {
            super(container);

        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)


            buttons.push(
                {
                    title: Q.text("Refresh"),	// *** Get button text from translation
                    cssClass: 'button-refresh',
                    icon: 'fa-refresh',
                    onClick: () => {

                        this.refresh();
                    },
                }
            );



            return buttons;
        }
        public DisableAddButton() {
            this.toolbar.findButton('add-button').toggleClass('disabled', true);
            Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
        }





        protected createSlickGrid() {
            var grid = super.createSlickGrid();


            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Qty'),
                    new Slick.Aggregators.Sum('BeforeDiscAmt'),
                    new Slick.Aggregators.Sum('DiscAmt'),
                    new Slick.Aggregators.Sum('AlocalteDiscAmt'),
                    new Slick.Aggregators.Sum('ItemExVat'),
                    new Slick.Aggregators.Sum('ItemVatAmt'),
                    new Slick.Aggregators.Sum('ItemExVatAmt')
                ]
            });
            return grid;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            // opt.frozenColumn = 1;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }



        public get CallPR(): string { return this._CallPR; }
        public get CallTAX(): string { return this._CallTax; }

        public get delPR(): string { return this._delPR; }
        public get delTAX(): string { return this._delTax; }

        public get sup(): string { return this._sup; }
        set sup(value: string) {
            if (this._sup != value) {
                console.log("whsid: " + value);
                //  var row =  this.view.getRows();
                this.clearDataGrid();
                this.refresh();
            }
        }


        set CallPR(value: string) {
            console.log(value)
            if (this.checkIsRow(value, 0) == false) {
                if (this._CallPR != value) {
                  
                        var row = PosTranDtRow.getLookup().items.filter(x => x.DocNo == value && x.LineItemType == "10")
                        // this.clearDataGrid();
                        var i = 0;
                        for (var po of row) {
                            // if(po.LineItemType =="10"){
                            i++;

                            if(po.ItemVatType == "V"){
                               

                            var item = <PsVatRefundDtRow>{
                                ItemNo: po.LineItemNo,
                                RefInv: value,
                                RefTaxNo: '',
                                PluCode: po.PluCode,
                                PluDesc: po.ItemDesc,
                                Qty: po.Qty,
                                Amt: po.ItemNetSales,
                                ItemVat: po.ItemVat,
                                ItemId: po.Id,
                                Cancel: 0
                            };
                             
                        

                            var id = this.getNextId();
                            //console.log("get id: " + this.getIdProperty());
                            item[this.getIdProperty()] = id;
                            this.view.addItem(item);
                        }
                        }
                        // }



                 

                }
            } else {
                var rows = this.view.getRows();
                for (var ad of rows) {

                    var ad = ad[this.getIdProperty()]
                    // console.log(ad)
                    var item = this.view?.getItemById?.(ad)
                    // console.log(item.__id)
                    console.log(item.RefInv  ==  value)
                    // console.log(item)
                    // console.log(ad)
                    if (item) {
                        if (item.RefInv == value) {

                            this.view.deleteItem(ad)
                        }
                    }

                }


                row = PosTranDtRow.getLookup().items.filter(x => x.DocNo == value && x.LineItemType == "10")
                        // this.clearDataGrid();
                        var i = 0;
                        for (var po of row) {
                            // if(po.LineItemType =="10"){
                            i++;

                            if(po.ItemVatType == "V"){
                            var item = <PsVatRefundDtRow>{
                                ItemNo: po.LineItemNo,
                                RefInv: value,
                                RefTaxNo: '',
                                PluCode: po.PluCode,
                                PluDesc: po.ItemDesc,
                                Qty: po.Qty,
                                Amt: po.ItemNetSales,
                                ItemVat: po.ItemVat,
                                ItemId: po.Id,
                                Cancel: 0
                            };

                            var id = this.getNextId();
                            //console.log("get id: " + this.getIdProperty());
                            item[this.getIdProperty()] = id;
                            this.view.addItem(item);
                        }
                        }




            }
            this.refresh();
        }

        set CallTAX(value: string) {
            if (this.checkIsRow(value, 1) == false) {
                if (this._CallTax != value) {

                    var row = PsTaxInvoiceDtRow.getLookup().items.filter(x => x.DocNo == value)

                    var docref = PsTaxInvoiceHdRow.getLookup().itemById[value].RefDocNo

                    // this.clearDataGrid();
                    var i = 0;
                    for (var po of row) {
                        // if(po.LineItemType =="10"){
                        i++;

                        if(po.VatType == "V"){
                        var item = <PsVatRefundDtRow>{
                            ItemNo: po.LineItemNo,
                            RefInv: docref,
                            RefTaxNo: value,
                            PluCode: po.PluCode,
                            PluDesc: po.ItemDescription,
                            Qty: po.Qty,
                            Amt: po.ItemNetSales,
                            ItemVat: po.ItemVatAmt,
                            ItemId: po.Id,
                            Cancel: 0
                        };
                   
                        var id = this.getNextId();
                        //console.log("get id: " + this.getIdProperty());
                        item[this.getIdProperty()] = id;
                        this.view.addItem(item);
                    }
                    }
                    // }


                }
            } else {
                var rows = this.view.getRows();
                for (var ad of rows) {

                    var ad = ad[this.getIdProperty()]

                    var item = this.view?.getItemById?.(ad)
                    if (item) {
                        if (item.RefTaxNo == value) {
                            this.view.deleteItem(ad)
                        }
                    }

                }

                row = PsTaxInvoiceDtRow.getLookup().items.filter(x => x.DocNo == value)

                    var docref = PsTaxInvoiceHdRow.getLookup().itemById[value].RefDocNo

                    // this.clearDataGrid();
                    var i = 0;
                    for (var po of row) {
                        // if(po.LineItemType =="10"){
                        i++;

                        if(po.VatType == "V"){
                        var item = <PsVatRefundDtRow>{
                            ItemNo: po.LineItemNo,
                            RefInv: docref,
                            RefTaxNo: value,
                            PluCode: po.PluCode,
                            PluDesc: po.ItemDescription,
                            Qty: po.Qty,
                            Amt: po.ItemNetSales,
                            ItemVat: po.ItemVatAmt,
                            ItemId: po.Id,
                            Cancel: 0
                        };
                   

                        var id = this.getNextId();
                        //console.log("get id: " + this.getIdProperty());
                        item[this.getIdProperty()] = id;
                        this.view.addItem(item);
                    }
                    }




            }
            this.refresh();
        }

        set delPR(value: string) {
            console.log(value)
            if (this.checkIsRow(value, 0) == false) {
                
            } else {
                var rows = this.view.getRows();
                for (var ad of rows) {

                    var ad = ad[this.getIdProperty()]
                    // console.log(ad)
                    var item = this.view?.getItemById?.(ad)
                    // console.log(item.__id)
                    console.log(item.RefInv  ==  value)
                    // console.log(item)
                    // console.log(ad)
                    if (item) {
                        if (item.RefInv == value) {

                            this.view.deleteItem(ad)
                        }
                    }

                }
            }
            this.refresh();
        }

        set delTAX(value: string) {
            console.log(value)
            if (this.checkIsRow(value, 1) == false) {
                
            } else {
                var rows = this.view.getRows();
                for (var ad of rows) {

                    var ad = ad[this.getIdProperty()]
                    // console.log(ad)
                    var item = this.view?.getItemById?.(ad)
                    // console.log(item.__id)
                   // console.log(item.RefInv  ==  value)
                    // console.log(item)
                    // console.log(ad)
                    if (item) {
                        if (item.RefTaxNo == value) {

                            this.view.deleteItem(ad)
                        }
                    }

                }
            }
            this.refresh();
        }

        public clearDataGrid() {
            this.view.setItems([], true);
        }

        private checkIsRow(uomId: string, uomType: number) {
            var rows = this.getItems();

            for (var row of rows) {
                if (uomType == 0) {
                    if (row.RefInv == uomId) {
                        return true;
                    }
                }
                if (uomType == 1) {
                    if (row.RefTaxNo == uomId) {
                        return true;
                    }
                }

            }
            return false;
        }


    }
}

